import { getLevelInfo } from '../../utils/scoring';

export const LevelDisplay = ({ sendItScore }) => {
  const level = getLevelInfo(sendItScore).currentLevel;

  return (
    <div className="mb-4 sm:mb-5 md:mb-6 px-3 sm:px-4">
      <div className={`relative bg-gradient-to-r ${level.bg} border-4 border-black px-4 sm:px-6 py-4 sm:py-5 shadow-2xl w-full max-w-2xl mx-auto overflow-hidden group hover:scale-105 transition-transform duration-300`}>
        {/* Animated background glow */}
        <div
          className="absolute inset-0 opacity-30 animate-pulse"
          style={{ background: `radial-gradient(circle at 50% 50%, ${level.color1}, transparent 70%)` }}
        />

        {/* Content */}
        <div className="relative z-10">
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center gap-2">
              <div
                className="w-3 h-3 sm:w-4 sm:h-4 rounded-full animate-pulse"
                style={{ backgroundColor: level.color1 }}
              />
              <span className="text-white/60 text-xs sm:text-sm font-black uppercase tracking-wide">Current Rank</span>
            </div>
          </div>

          <div className={`text-2xl sm:text-4xl md:text-5xl font-black ${level.color} uppercase tracking-tight leading-none mb-3 truncate`}>
            {level.title}
          </div>

          <div className="text-center py-2">
            <span className="text-white/80 text-sm sm:text-base font-bold">{level.message}</span>
          </div>
        </div>

        {/* Corner decoration */}
        <div
          className="absolute top-0 right-0 w-16 h-16 sm:w-20 sm:h-20 opacity-20 transform rotate-45 translate-x-8 -translate-y-8"
          style={{ background: level.color1 }}
        />
      </div>
    </div>
  );
};
